import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AdminLayout from './components/AdminLayout';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Programs from './pages/Programs';
import ProgramDetail from './pages/ProgramDetail';
import Screening from './pages/Screening';
import Payment from './pages/Payment';
import Dashboard from './pages/Dashboard';
import LearningPath from './pages/LearningPath';
import SectionContent from './pages/SectionContent';
import Assessment from './pages/Assessment';
import Profile from './pages/Profile';
import Certificate from './pages/Certificate';
import InternshipEnrollment from './pages/InternshipEnrollment';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import ChangePassword from './pages/ChangePassword';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminPrograms from './pages/admin/AdminPrograms';
import AdminAssessments from './pages/admin/AdminAssessments';
import AdminContent from './pages/admin/AdminContent';
import AdminEnrollments from './pages/admin/AdminEnrollments';
import AdminInternships from './pages/admin/AdminInternships';
import AdminStudents from './pages/admin/AdminStudents';
import { isAuthenticated } from './utils/auth';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function ProtectedRoute({ children }) {
  return isAuthenticated() ? children : <Navigate to="/login" />;
}

function AdminProtectedRoute({ children }) {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  if (!isAuthenticated()) {
    return <Navigate to="/login" />;
  }
  if (!user.isAdmin) {
    return <Navigate to="/dashboard" />;
  }
  return children;
}

function App() {
  const [isAuth, setIsAuth] = useState(isAuthenticated());

  useEffect(() => {
    const interval = setInterval(() => {
      setIsAuth(isAuthenticated());
    }, 10000); // Check every 10 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <Router>
      <div className="d-flex flex-column min-vh-100">
        <Navbar />
        <main className="flex-grow-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/programs/:slug" element={<ProgramDetail />} />
            <Route path="/profile/:userId" element={<Profile />} />
            
            {/* Auth Routes */}
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/verify-email/:token" element={<VerifyEmail />} />
            
            {/* Protected Routes */}
            <Route path="/screening/:enrollmentId" element={<ProtectedRoute><Screening /></ProtectedRoute>} />
            <Route path="/payment/:enrollmentId" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/learning/:enrollmentId" element={<ProtectedRoute><LearningPath /></ProtectedRoute>} />
            <Route path="/content/:programId/:sectionOrder" element={<ProtectedRoute><SectionContent /></ProtectedRoute>} />
            <Route path="/assessment/:assessmentId" element={<ProtectedRoute><Assessment /></ProtectedRoute>} />
            <Route path="/certificate/:enrollmentId" element={<ProtectedRoute><Certificate /></ProtectedRoute>} />
            <Route path="/internship/:enrollmentId" element={<ProtectedRoute><InternshipEnrollment /></ProtectedRoute>} />
            <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
            
            {/* Admin Routes */}
            <Route path="/admin" element={<AdminProtectedRoute><AdminLayout /></AdminProtectedRoute>}>
              <Route index element={<Navigate to="/admin/dashboard" />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="programs" element={<AdminPrograms />} />
              <Route path="assessments" element={<AdminAssessments />} />
              <Route path="content" element={<AdminContent />} />
              <Route path="enrollments" element={<AdminEnrollments />} />
              <Route path="internships" element={<AdminInternships />} />
              <Route path="students" element={<AdminStudents />} />
            </Route>
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
